import {
    FETCH_SEARCH_BEGIN,
    FETCH_SEARCH_SUCCESS,
    FETCH_SEARCH_RESULTS_BEGIN,
    FETCH_SEARCH_DATA_SUCCESS,
    FETCH_SEARCH_RESULTS_SUCCESS,
    CLEAR_SEARCH_CHIPS,
    ADD_SEARCH_CHIP,
    REMOVE_SEARCH_CHIP,
    REMOVE_LAST_SEARCH_CHIP,
    ADD_SEARCH_CHIPS,
    STORE_SEARCH_FILTER,
    CLEAR_SEARCH_FILTER,
    FETCH_JIRA_UNITS_BEGINS,
    FETCH_JIRA_UNITS_SUCCESS,
    GET_FILTER
} from '../actions/searchActions';

const initialState = {
    searchKey: 0,
    searchObject: [],
    units: [],
    allRecords: [],
    chips: [],
    mainSearch: [],
    pagination: {
        page_limit: 0,
        total_pages: 0,
        total_records: 0,
        current_page: 0,
    },
    loading: false,
    error: null,
    column: "",
    direction: "",
    active: ""
};

export default function searchReducer(state = initialState, action) {

    switch (action.type) {
        case FETCH_SEARCH_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                search_results: action.payload.result
            };

        case FETCH_SEARCH_DATA_SUCCESS:
            return {
                ...state,
                searchObject: action.payload.result,
                // loading: false
            };

        case ADD_SEARCH_CHIP:
            return {
                ...state,
                chips: [...state.chips, action.payload]
            };
        case ADD_SEARCH_CHIPS:
            return {
                ...state,
                chips: action.payload
            };
        case REMOVE_LAST_SEARCH_CHIP:
            return {
                ...state,
                chips: [...state.chips.slice(0, -1)]
            };
        case REMOVE_SEARCH_CHIP:
            return {
                ...state,
                chips: [
                    ...state.chips.slice(0, action.payload),
                    ...state.chips.slice(action.payload + 1)
                ]
            };

        case FETCH_SEARCH_RESULTS_SUCCESS:
            return {
                ...state,
                units: action.payload.result.units,
                pagination: action.payload.result.pagination,
                loading: false,
            };
        case STORE_SEARCH_FILTER:
            return {
                ...state,
                column: action.payload.column,
                direction: action.payload.direction,
                active:  action.payload.column
            };
        case  CLEAR_SEARCH_FILTER:
            return {
                ...state,
                active: "",
                direction: "",
                column: ""
            }
        case FETCH_SEARCH_RESULTS_BEGIN:
            return {
                ...state,
                loading: true,
                pagination: {
                    ...state.pagination,
                    current_page: action.payload
                }
            };

        case CLEAR_SEARCH_CHIPS:
            return {
                ...state,
                chips: []
            };
        case GET_FILTER:
            return {
                ...state,
                mainSearch: action.payload
            };
        case FETCH_JIRA_UNITS_BEGINS: {
            return {
                ...state,
                loading: true,
                pagination: {
                    ...state.pagination,
                    current_page: action.payload
                }
            };
        }
        case FETCH_JIRA_UNITS_SUCCESS: {
            return {
                ...state,
                loading: false,
                units: action.payload.result.units,
                pagination: action.payload.result.pagination
            };
        }

        default:
            return state;
    }
}
